module.exports = __webpack_public_path__ + "media/elevadizo/buqueDerecha-ap-21926a21.png";